import { Component, ViewChild,AfterViewInit,ElementRef,Output,EventEmitter,Input } from '@angular/core';

import {Modal} from 'ng2-modal';
import { Layout } from '../services/layout/layout-manager';
import {LayoutManagerService} from '../services/layout/layout-manager.service';
import { environment } from 'environments/environment.pre';

@Component({
  selector: "dskl-tools-media-control",
  templateUrl: 'media-control.component.html',
})
export class MediaControlComponent {
  @ViewChild("mediaControlModal") mediaControlModal: Modal;
  
  constructor(private layoutService: LayoutManagerService){}
  open(){
    this.mediaControlModal.open();
    
  }
  environment(){
    return environment;
  }
  setFullscreen(){
    
    this.layoutService.setFullscreen();
  }
  updateMedia(media){
    var layout;
    switch (media){
      case "both": layout = Layout.VIDEOS_WB; break;
      case "audio": layout = Layout.AUDIO_WB; break;
     case "teacher-presentation-both": layout = Layout.TEACHER_PRESENTATION_BOTH; break;
     case "teacher-presentation-audio": layout = Layout.TEACHER_PRESENTATION_AUDIO; break;
     case "none": layout = Layout.NONE; break;
     case "audio-snapshots": layout = Layout.AUDIO_SNAPSHOTS; break;
    }
    console.log("Will change layout to ", Layout[layout]);
   this.layoutService.changeLayout(Layout[layout]);
    //this.wsService.send("update_classroom_media", {media: media});
    this.mediaControlModal.close();
  }
}


// WEBPACK FOOTER //
// /app/src/app/wb/tools/media-control.component.ts